import { createSlice } from '@reduxjs/toolkit';
import FJConstant from '../../constants/FJConstant';

export const AI_VIDEO_DUB_USE_CREDIT = 0.3;

export const FJSliceAiVideoDub = createSlice({
    name: 'aiVideoDub',
    initialState: {
        videoInfo: {},
        trimVideoInfo: {},

        // 裁剪弹窗裁剪信息
        trimModelInfo: {
            start: 0,
            end: 5,
        },
        // 裁剪信息
        trimInfo: {
            start: 0,
            end: 5,
        },
        trimLoading: false,

        prompts: '',
        removeOriginAudio: false,

        presetListStatus: FJConstant.DEFAULT,
        presetList: [],

        resultInfo: {
            videoUrl: '',
            width: 0,
            height: 0,
        },

        resultAudioInfo: {
            audioUrl: '',
        },
        resultAudioInfoStatus: FJConstant.DEFAULT,

        thumbnailUrl: '',
        audioWavesurferUrl: '',
        progress: 0,

        /**
         * @desc 预计生成总时长
         */
        generateAllTime: 0,

        useCredit: 0,

        isUploadFileLoading: false,
    },
    reducers: {
        setVideoInfo: (state, action) => {
            state.videoInfo = action.payload;
        },

        setSliceTrimInfo: (state, action) => {
            state.trimInfo = action.payload;
            state.generateAllTime = (action.payload.end - action.payload.start) * 4.5;
            state.useCredit = Number(
                (Math.round(action.payload.end - action.payload.start) * AI_VIDEO_DUB_USE_CREDIT).toFixed(1),
            );
        },

        setSliceTrimVideoInfo: (state, action) => {
            state.trimVideoInfo = action.payload;
        },

        setSlicePrompts: (state, action) => {
            state.prompts = action.payload;
        },

        setSliceRemoveOriginAudio: (state, action) => {
            state.removeOriginAudio = action.payload;
        },

        setSlicePresetList: (state, action) => {
            state.presetList = action.payload;
        },

        setSlicePresetListStatus: (state, action) => {
            state.presetListStatus = action.payload;
        },

        setSliceResultInfo: (state, action) => {
            state.resultInfo = action.payload;
        },

        setSliceThumbnailUrl: (state, action) => {
            state.thumbnailUrl = action.payload;
        },

        setSliceAudioWavesurferUrl: (state, action) => {
            state.audioWavesurferUrl = action.payload;
        },

        setSliceResultAudioInfo: (state, action) => {
            state.resultAudioInfo = action.payload;
        },

        setSliceResultAudioInfoStatus: (state, action) => {
            state.resultAudioInfoStatus = action.payload;
        },

        setSliceProgress: (state, action) => {
            state.progress = action.payload;
        },

        setSliceTrimModelInfo: (state, action) => {
            state.trimModelInfo = action.payload;
        },

        setSliceIsUploadFileLoading: (state, action) => {
            state.isUploadFileLoading = action.payload;
        },
    },
});

export const {
    setVideoInfo,
    setSliceTrimInfo,
    setSliceTrimVideoInfo,
    setSlicePrompts,
    setSliceRemoveOriginAudio,
    setSlicePresetList,
    setSlicePresetListStatus,
    setSliceResultInfo,
    setSliceThumbnailUrl,
    setSliceAudioWavesurferUrl,
    setSliceResultAudioInfo,
    setSliceResultAudioInfoStatus,
    setSliceProgress,
    setSliceTrimModelInfo,
    setSliceIsUploadFileLoading,
} = FJSliceAiVideoDub.actions;

export default FJSliceAiVideoDub.reducer;
